import type { EmbeddedSignupResult } from "./embedded-signup-session.js";

export const WHATSAPP_SIGNUP_HANDOFF_EVENT = "multi-chat:whatsapp-signup-handoff";

export interface WhatsAppSignupHandoff {
  organizationId: number;
  result: EmbeddedSignupResult;
}

let pendingSignup: WhatsAppSignupHandoff | null = null;

export function handoffWhatsAppSignup(handoff: WhatsAppSignupHandoff): void {
  pendingSignup = handoff;
}

export function takeWhatsAppSignupHandoff(): WhatsAppSignupHandoff | null {
  const handoff = pendingSignup;
  pendingSignup = null;
  return handoff;
}

/**
 * Returns the Embedded Signup result only for the organization that started it.
 * A mismatch puts the handoff back so another organization cannot submit it,
 * and the original organization can still claim it once.
 */
export function claimWhatsAppSignupHandoff(organizationId: number): EmbeddedSignupResult | null {
  const handoff = takeWhatsAppSignupHandoff();
  if (!handoff) return null;
  if (handoff.organizationId !== organizationId) {
    handoffWhatsAppSignup(handoff);
    return null;
  }
  return handoff.result;
}
